/* =====================================================================
   REDIRECT por Product ID -> slug  (outletmxn.shop)
   ---------------------------------------------------------------------
   Ao clicar em comprar, identifica o produto pela sua Product ID e
   redireciona para outletmxn.shop/<slug>. Produto não mapeado segue o
   fluxo normal da loja (não bloqueia).
   ===================================================================== */
(function () {
  "use strict";

  const BASE = "https://outletmxn.shop";

  // Product ID  ->  slug
  const MAP = {
    "10447186428187": "/kit-perfumes-mx-01",
    "10447186985243": "/kit-perfumes-mx-02",
    "10447187050779": "/kit-perfumes-mx-03",
    "10447187116315": "/kit-perfumes-mx-04",
    "10447186133275": "/kit-perfumes-mx-05",
    "10447186854171": "/kit-perfumes-mx-06",
    "10447186723099": "/kit-perfumes-mx-07",
    "10447186329883": "/kit-perfumes-mx-08",
    "10447187214619": "/kit-perfumes-mx-09",
    "10447186952475": "/kit-perfumes-mx-10",
    "10447186198811": "/kit-perfumes-mx-11",
    "10447186067739": "/kit-perfumes-mx-12",
    "10447185674523": "/kit-perfumes-mx-13",
    "10447185543451": "/kit-perfumes-mx-14",
    "10447187476763": "/kit-perfumes-mx-15",
    "10447187411227": "/kit-perfumes-mx-16",
    "10447187345691": "/kit-perfumes-mx-17",
    "10447187280155": "/kit-perfumes-mx-18",
    "10447187181851": "/kit-perfumes-mx-19",
    "10447186821403": "/kit-perfumes-mx-20",
    "10447186755867": "/kit-perfumes-mx-21",
    "10447186657563": "/kit-perfumes-mx-22",
    "10447186592027": "/kit-perfumes-mx-23",
    "10447186526491": "/kit-perfumes-mx-24",
    "10447186264347": "/kit-perfumes-mx-25",
    "10447186034971": "/kit-perfumes-mx-26",
    "10447185969435": "/kit-perfumes-mx-27",
    "10447185903899": "/kit-perfumes-mx-28",
    "10447185805595": "/kit-perfumes-mx-29",
    "10447185772827": "/kit-perfumes-mx-30",
    "10447185608987": "/kit-perfumes-mx-31",
  };

  // Botão(ões) de compra a interceptar (ajuste se o tema usar outro)
  const ADD_SELECTOR = 'button[name="add"], [type="submit"][name="add"], [data-testid="standalone-add-to-cart"]';

  // Descobre a Product ID do produto (por forma, global da Shopify ou data-attr)
  function productIdFor(btn) {
    const formId = btn.getAttribute("form");
    const form = (formId && document.getElementById(formId)) || btn.closest("form");
    const fpid = form?.querySelector('[name="product-id"]')?.value;
    if (fpid) return String(fpid);
    const g = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id;
    if (g) return String(g);
    const el = btn.closest("[data-product-id]") || document.querySelector("[data-product-id]");
    const d = el && el.getAttribute("data-product-id");
    return d ? String(d) : "";
  }

  let emAndamento = false;
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(ADD_SELECTOR);
    if (!btn) return;
    const pid = productIdFor(btn);
    const slug = MAP[pid];
    if (!slug) { console.warn("[redir] produto sem slug mapeado:", pid); return; } // segue fluxo normal
    e.preventDefault();
    e.stopImmediatePropagation();
    if (emAndamento) return;
    emAndamento = true;
    console.log("[redir] produto", pid, "->", BASE + slug);
    window.location.href = BASE + slug;
  }, true);

  console.log("[redir] script carregado.", Object.keys(MAP).length, "produtos mapeados.");
})();